var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.toast)?_c('div',{staticClass:"toast-wrap"},[_c('div',{staticClass:"toast"},[_c('span',{staticClass:"toast-icon"},[_vm._v("✓")]),_vm._v(" "+_vm._s(_vm.toast)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }